/** Best-effort public IP for client-side session logging (web app cannot read server-side IP). */
export async function captureClientPublicIp(): Promise<string | undefined> {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    const res = await fetch('https://api.ipify.org?format=json', { signal: controller.signal });
    clearTimeout(timeout);
    if (!res.ok) return undefined;
    const data = await res.json() as { ip?: string };
    return data.ip;
  } catch {
    return undefined;
  }
}
